"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultComboboxMultiselectComponents = exports.defaultComboboxComponents = exports.ComboboxCreateItem = exports.ComboboxEmptyItem = exports.ComboboxLoadingItem = exports.ComboboxMultiselectSelectedItem = exports.ComboboxMultiselectMenuItem = exports.ComboboxMenuItem = void 0;
var react_1 = __importStar(require("react"));
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
var Spinner_1 = require("../Spinner");
var TimesDefault_1 = __importDefault(require("../Icon/generated/TimesDefault"));
var HFlow_1 = require("../HFlow");
var Checkbox_1 = require("../Checkbox");
exports.ComboboxMenuItem = react_1.default.forwardRef(function (props, ref) {
    var children = props.children, item = props.item, style = props.style, selected = props.selected, highlighted = props.highlighted, itemToString = props.itemToString, index = props.index, rest = __rest(props, ["children", "item", "style", "selected", "highlighted", "itemToString", "index"]);
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("li", __assign({ ref: ref, className: css(classes.item, (selected || highlighted) && classes.selected, style) }, rest), children !== null && children !== void 0 ? children : itemToString(item)));
});
exports.ComboboxMultiselectMenuItem = react_1.default.forwardRef(function (props, ref) {
    var children = props.children, item = props.item, style = props.style, selected = props.selected, highlighted = props.highlighted, itemToString = props.itemToString, index = props.index, rest = __rest(props, ["children", "item", "style", "selected", "highlighted", "itemToString", "index"]);
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("li", __assign({ ref: ref, className: css(classes.item, highlighted && classes.selected, style) }, rest),
        react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 0.5, alignItems: 'center' },
            react_1.default.createElement(Checkbox_1.Checkbox, { style: { pointerEvents: 'none' }, checked: selected, tabIndex: -1, readOnly: true }), children !== null && children !== void 0 ? children : itemToString(item))));
});
exports.ComboboxMultiselectSelectedItem = react_1.forwardRef(function (props, ref) {
    var style = props.style, children = props.children, onRemove = props.onRemove, disabled = props.disabled, rest = __rest(props, ["style", "children", "onRemove", "disabled"]);
    var _a = styles_1.useStyles(createStyles, props), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("span", __assign({ ref: ref, className: css(classes.multiItemContainer, style) }, rest),
        react_1.default.createElement("span", { className: disabled ? classes.multiItemTextDisabled : classes.multiItemText }, children),
        !disabled && (react_1.default.createElement("span", { className: classes.multiItemButton, onClick: onRemove, title: locale.combobox.removeItem },
            react_1.default.createElement(TimesDefault_1.default, null)))));
});
function ComboboxLoadingItem(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("li", __assign({ className: css(classes.item, classes.loadingItem, style) }, rest),
        locale.combobox.loadingItem,
        react_1.default.createElement(Spinner_1.Spinner, { style: classes.loadingSpinner })));
}
exports.ComboboxLoadingItem = ComboboxLoadingItem;
function ComboboxEmptyItem(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var locale = i18n_1.useLocale();
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("li", __assign({ className: css(classes.item, style) }, rest), locale.combobox.emptyItem));
}
exports.ComboboxEmptyItem = ComboboxEmptyItem;
function ComboboxCreateItem(props) {
    var style = props.style, rest = __rest(props, ["style"]);
    var locale = i18n_1.useLocale();
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("li", __assign({ className: css(classes.item, style) }, rest), locale.combobox.createItem));
}
exports.ComboboxCreateItem = ComboboxCreateItem;
exports.defaultComboboxComponents = {
    AppendItem: function () { return null; },
    PrependItem: function () { return null; },
    CreateItem: function () { return react_1.default.createElement(ComboboxCreateItem, null); },
    LoadingItem: function () { return react_1.default.createElement(ComboboxLoadingItem, null); },
    EmptyItem: function () { return react_1.default.createElement(ComboboxEmptyItem, null); },
    Item: exports.ComboboxMenuItem,
};
exports.defaultComboboxMultiselectComponents = __assign(__assign({}, exports.defaultComboboxComponents), { SelectedItem: exports.ComboboxMultiselectSelectedItem, Item: exports.ComboboxMultiselectMenuItem });
var createStyles = function (theme) { return ({
    item: __assign(__assign({}, theme.typography.variant('main')), { borderBottom: "1px solid " + theme.pallete.divider, cursor: 'pointer', padding: '0.5rem 0.5rem', transition: '.1s ease', '&:last-of-type': {
            borderBottom: 'none',
        }, '&:hover': {
            background: theme.pallete.surface.background,
        }, '&:focus': {
            outline: 0,
            borderRadius: 3,
            boxShadow: styles_1.focusBoxShadow(theme, 'primary', 'inset'),
        } }),
    loadingItem: {
        background: theme.pallete.surface.background,
        paddingTop: '0.25rem',
        paddingBottom: '0.25rem',
        cursor: 'initial',
    },
    loadingSpinner: {
        color: theme.pallete.primary.main,
        float: 'right',
    },
    selected: {
        outline: 0,
        background: theme.pallete.surface.background,
    },
    multiItemContainer: {
        border: "1px solid " + theme.pallete.divider,
        borderRadius: theme.radius.button,
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 'bold',
    },
    multiItemText: {
        padding: 'calc(0.125rem - 1px) 0.25rem',
    },
    multiItemTextDisabled: {
        padding: 'calc(0.25rem - 1px) 0.25rem',
    },
    multiItemButton: {
        background: theme.pallete.surface.background,
        cursor: 'pointer',
        fontSize: '1.25rem',
        display: 'inline-flex',
        alignItems: 'center',
        padding: 'calc(0.125rem - 1px) 0',
        '&:hover': {
            color: theme.pallete.status.danger.main,
        },
        svg: {
            fill: 'currentColor',
        },
    },
}); };
//# sourceMappingURL=ComboboxMenuComponents.js.map